'use strict';

/*global app*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/

function ReceiptService() {
  this.$container = $('body');

  this.isLoading = false;

  this.init();
}

ReceiptService.prototype = $.extend({}, {
  constructor: 'ReceiptService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  confirmReceiptCardByWebDocument: function confirmReceiptCardByWebDocument(webDocumentRID, callback) {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('receipt:confirm_receipt_card_by_web_document', { WebDocumentRID: webDocumentRID }, function (res) {
      unBlockElement(_this.$container);

      if (res.msg === 'SUCCESS') {
        invokeCallback(callback);
      } else {
        app.viewErrorMessage(res);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

